<template>
	<div class="navigation__item" :token="id" v-bind:class="{ active: isActive }" v-scroll-top-navigation="{container: navigationToken}" v-hamburger-link @click="clickToggler">
		<a :href="BASE_URL + '#' + id">{{label}}</a>
	</div>
</template>

<script>

export default {
	name: "NavigationItem",
	props: [ 'label', 'id', 'isActive', 'navigationToken' ],
	methods: {
		clickToggler: function() {
			this.$emit('toggleMenu');
		}
	},
	data: function() {
		return {
			BASE_URL: process.env.BASE_URL
		};
	}
}
</script>